import {
  DefaultItemColumnWidth,
  DefaultCompactItemColumnWidth,
  DefaultColumnWidth,
  DefaultItemColumnSegmentWidth,
  MobileItemColumnWidths,
  ItemColumnSegmentWidths,
  ItemColumnWidths,
  ColumnWidths,
  MobileNoteColumnWidths,
} from 'flux/stores/cuesheet/CuesheetConstants';
import capitalize from 'underscore.string/capitalize';

/**
 * Common cuesheet functionality...start to migrate stuff here when you can!
 *
 * This should have things reusable stuff across all cuesheet components
 */
export default {
  getItemColumnWidth(settings, isCompactView) {
    let width = settings.getIn(['itemColumn', 'width']);

    if (isCompactView) {
      width =
        ItemColumnSegmentWidths[capitalize(width)] ||
        DefaultCompactItemColumnWidth;
    } else {
      width = ItemColumnWidths[capitalize(width)] || DefaultItemColumnWidth;
    }

    return width;
  },

  getMobileItemColumnWidth(width) {
    return MobileItemColumnWidths[capitalize(width)] || DefaultColumnWidth;
  },

  getMobileNoteColumnWidth(width) {
    return MobileNoteColumnWidths[capitalize(width)] || DefaultColumnWidth;
  },

  getItemColumnSegmentWidth(settings) {
    let width = settings.getIn(['itemColumn', 'width']);

    width =
      ItemColumnSegmentWidths[capitalize(width)] ||
      DefaultItemColumnSegmentWidth;

    return width;
  },

  getColumnWidth(width) {
    return ColumnWidths[capitalize(width)] || DefaultColumnWidth;
  },

  getColumnWidthClass(width) {
    width = width || DefaultColumnWidth;
    return `cs-cell-width-${width}`;
  },

  getCuesheetWidth(settings, userSettings, columns) {
    return (
      this.getItemColumnWidth(settings) +
      this.getColumnWidth(userSettings.getIn(['noteColumn', 'width'])) +
      columns.reduce((w, col) => w + this.getColumnWidth(col.get('width')), 0)
    );
  },

  /**
   * Check to see if cell is selected
   *
   * @param rowIndex
   * @param cellIdentifier - This will be the columnId if the cell type
   * is Data or will be the cell type {Item, Note, etc.} if it is not Data type.
   */
  isCellSelected(rowIndex, cellIdentifier, state) {
    if (!state) return;

    let rowPath = state.getIn(['rows', rowIndex, 'path']),
      rowId = rowPath ? rowPath[2] : null;

    return rowId && state.getIn(['selectedCells', `${rowId}_${cellIdentifier}`])
      ? true
      : false;
  },

  /**
   * Check to see if cell is collab cell
   *
   * @param rowIndex
   * @param cellIdentifier - This will be the columnId if the cell type
   * is Data or will be the cell type {Item, Note, etc.} if it is not Data type.
   */
  isCollabCell(rowIndex, cellIdentifier, state) {
    if (!state) return;
    const rowPath = state.getIn(['rows', rowIndex, 'path']);
    const rowId = rowPath ? rowPath[2] : null;
    return rowId && state.getIn(['collabCells', `${rowId}_${cellIdentifier}`])
      ? state.getIn(['collabCells', `${rowId}_${cellIdentifier}`])
      : false;
  },
};
